// @flow
import { commitMutation, graphql } from 'react-relay';

export const mutation = graphql`
  mutation CartV2ToggleAutoshipMutation(
    $input: CartV2ToggleAutoshipMutationInput!
  ) {
    cartV2ToggleAutoship(input: $input) {
      cartV2 {
        id
        autoShipEnabled
        autoShipIntervalUnit
        autoShipIntervalCount
        subTotalPriceOfItems
        subTotalPriceOfItemsWithDiscount
      }
    }
  }
`;


function commit({ environment, onCompleted, onError }) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {},
    },
    onCompleted,
    onError,
  });
}

export default { commit };
